import {
    SET_COMPANY_INFO, CLEAR_COMPANY_INFO, SET_COMPANY_INFO_IS_OPEN, SET_SELECTED_COMPANY_INFO
} from '../actions/companyInfoActions';

export function companyReducer(prevState: any = [], action: any = {}) {
    switch (action.type) {
        case SET_COMPANY_INFO:
            return [...prevState, action.companyInfo];
        case CLEAR_COMPANY_INFO:
            return [];
        default:
            return prevState;
    }
}

export function companyInfoIsOpenedReducer(prevState: any = [], action: any = {}) {
    switch (action.type) {
        case SET_COMPANY_INFO_IS_OPEN:
            return action.isCompanyInfoOpen;
        default:
            return prevState;
    }
}
export function selectedCompanyInfoReducer(prevState: any = {}, action: any = {}) {
    switch (action.type) {
        case SET_SELECTED_COMPANY_INFO:
            return { ...prevState, ...action.selectedCompanyInfo };
        default:
            return prevState;
    }
}
